"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactInfiniteScroller = _interopRequireDefault(require("react-infinite-scroller"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _MarketplaceProductsList = _interopRequireDefault(require("../MarketplaceProductsList/MarketplaceProductsList"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    noProductText: {
      color: palette.grey.dark
    },
    wrapper: {
      width: '100%'
    }
  };
});
/**
 * Shared marketplace between sender and recipient parts.
 *
 * @param {object} props
 * @param {boolean}props.isLoading
 * @param {IProduct[]} props.products
 * @param {function(IProduct): void} props.renderItem
 * @param {function(): void} props.renderFakeItem
 * @param {function(): void} props.renderFakeProduct
 * @param {function(): void} props.renderEmpty
 * @param {function(number): void} props.loadNextPage
 * @param {boolean} props.hasMore
 * @param {ReactElement} [props.loader=undefined]
 * @param {Partial<BoxProps>} [props.productsWrapperProps = {}]
 * @param {Partial<IMarketplaceProductSkeletonProps>} [props.skeletonProps = {}]
 * @param {number} props.fakeItemsCount
 *
 * @returns {ReactElement}
 */

var SharedMarketplace = function SharedMarketplace(_ref2) {
  var isLoading = _ref2.isLoading,
      products = _ref2.products,
      renderItem = _ref2.renderItem,
      renderFakeItem = _ref2.renderFakeItem,
      renderFakeProduct = _ref2.renderFakeProduct,
      renderEmpty = _ref2.renderEmpty,
      loadNextPage = _ref2.loadNextPage,
      hasMore = _ref2.hasMore,
      loader = _ref2.loader,
      _ref2$productsWrapper = _ref2.productsWrapperProps,
      productsWrapperProps = _ref2$productsWrapper === void 0 ? {} : _ref2$productsWrapper,
      _ref2$skeletonProps = _ref2.skeletonProps,
      skeletonProps = _ref2$skeletonProps === void 0 ? {} : _ref2$skeletonProps,
      _ref2$fakeItemsCount = _ref2.fakeItemsCount,
      fakeItemsCount = _ref2$fakeItemsCount === void 0 ? 12 : _ref2$fakeItemsCount;
  var classes = useStyles();
  var emptyItems = (0, _react.useMemo)(function () {
    var hasNoProducts = !isLoading && !hasMore && products.length === 0;

    if (hasNoProducts && !renderEmpty) {
      return /*#__PURE__*/_react["default"].createElement(_material.Box, {
        width: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
        className: (0, _classnames["default"])(classes.noProductText, 'Body-Regular-Center-Static')
      }, "No products"));
    }

    if (hasNoProducts && renderEmpty) {
      return renderEmpty();
    }

    return undefined;
  }, [renderEmpty, isLoading, hasMore, products, classes]);
  return /*#__PURE__*/_react["default"].createElement(_reactInfiniteScroller["default"], {
    initialLoad: false,
    pageStart: 1,
    loadMore: loadNextPage,
    hasMore: hasMore,
    loader: loader,
    threshold: 100,
    className: classes.wrapper
  }, /*#__PURE__*/_react["default"].createElement(_MarketplaceProductsList["default"], {
    isLoading: isLoading,
    products: products,
    wrapperProps: productsWrapperProps,
    skeletonProps: skeletonProps,
    fakeItemsCount: fakeItemsCount,
    renderItem: renderItem,
    renderFakeItem: renderFakeItem,
    renderFakeProduct: renderFakeProduct
  }), emptyItems);
};

var _default = SharedMarketplace;
exports["default"] = _default;